import * as React from 'react';
import {
  Edit,
  SimpleForm,
} from 'react-admin';
import ScientificLiteratureKeywordForm from './ScientificLiteratureKeywordForm';
import FormToolbar from '../shared/FormToolbar';

const ScientificLiteratureKeywordEdit = props => (
  <Edit {...props} undoable={false}>
    <SimpleForm
      toolbar={<FormToolbar />}
      redirect="list"
    >
      <ScientificLiteratureKeywordForm {...props} />
    </SimpleForm>
  </Edit>
);

export default ScientificLiteratureKeywordEdit;
